/* oxlint-disable import/no-unassigned-import -- global stylesheet and side-effect imports */
import { createRoot } from 'react-dom/client';
import numbro from 'numbro';
import deDe from 'numbro/languages/de-DE';
import './index.css';
import { defineCustomElements } from '@duetds/date-picker/dist/loader';
import App from './App';
import { initMatomo } from './initMatomo';
import './styles';

numbro.registerLanguage(deDe);

void defineCustomElements(window);
initMatomo();

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
}
